import React from "react";
import { useSelector } from "react-redux";
import Plus18 from "../assets/images/icons/18plus.webp";
import Secure from "../assets/images/icons/secure.png";
import GameCare from "../assets/images/icons/gamecare.webp";
import GT from "../assets/images/icons/gt.png";

const BeforeLoginFooter = () => {
  const { appDetails } = useSelector((state) => state.app);
  return (
    <>
      <footer className="footer">
        <div className="footer-links">
          <ul>
            <li>
              <a href="/contacts">Contact Us</a>
            </li>
            <li>
              <a href="/privacypolicys">Privacy Policy</a>
            </li>

            <li>
              <a href="/ResponsibleGamings">Responsible Gaming</a>
            </li>
            <li>
              <a href="/fairplays">Fair Play</a>
            </li>
            <li>
              <a href="/gameruless">Games Rules</a>
            </li>
            <li>
              <a href="/termsandconditions">Terms and Conditions</a>
            </li>
          </ul>
          <div className="Support">24X7 Support</div>
        </div>
      </footer>
    </>
  );
};

export default BeforeLoginFooter;
